export const messengerWidgetWidth = 380
export const messengerWidgetShadowOffset = 24
export const messengerMobileSideAndBottomSpacing = 5
export const messengerChatScrollBarId = 'chat-scrollbar'
export const messengerChatScrollBarThreshold = 16
export const messengerChatNewMessageDividerId = 'chat-new-message-divider'
export const messengerMessageMaxLength = 10000
export const messengerEmojiLoadedEventName = 'emoji-loaded'
export const messengerMaxFileSize = 10 * 1024 * 1024 // 10MB
export const messengerMaxFilesCountPerMessage = 5
export const messengerAcceptedFileExtensions = [
  '.doc',
  '.docx',
  '.odt',
  '.xls',
  '.xlsx',
  '.xlsm',
  '.ods',
  '.numbers',
  '.csv',
  '.pdf',
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.svg',
  '.tiff',
  '.ico',
  '.webp',
  '.aif',
  '.aiff',
  '.aifc',
  '.aifr',
  '.mid',
  '.midi',
  '.mp3',
  '.mpa',
  '.ogg',
  '.wav',
  '.wma',
  '.3g2',
  '.3gp',
  '.avi',
  '.flv',
  '.h264',
  '.m4v',
  '.mkv',
  '.mov',
  '.mp4',
  '.mpg',
  '.mpeg',
  '.wmv',
  '.key',
  '.odp',
  '.pps',
  '.ppt',
  '.pptx',
  '.email',
  '.eml',
  '.emlx',
  '.msg',
  '.oft',
  '.ost',
  '.pst',
  '.vcf',
  '.html',
]

export const messengerMaxViewScrollHeight = 652
